import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=c219c06c"
import script from "./SelectCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCategory.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c219c06c')) {
      api.createRecord('c219c06c', component.options)
    } else {
      api.reload('c219c06c', component.options)
    }
    module.hot.accept("./SelectCategory.vue?vue&type=template&id=c219c06c", function () {
      api.rerender('c219c06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/ambience/category/components/SelectCategory.vue"
export default component.exports